module.exports = __webpack_public_path__ + "img/exante_assistenza_singolo.34393838.jpg";